module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-loading"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-84b888b6!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/loading/src/loading.vue
// module id = 143
// module chunks = 2 3